<template>
<div style="padding-bottom:40px;">
    <div class="paddingl20 bg-white">
        <div class="borderb paddingv30 paddingr20 pos-r" v-for="item in data">
            <span class="pos-a" style="top: -50px" :id="'comment-'+item.id"></span>
            <div class="flex-container left" @click="chooseOne(item.nickName, item)">
                <div class="pos-r">
                    <div class="img-container round marginr20" >
                        <img :src="item.photoUrl||'//image1.51tiangou.com/tgou2/img2/fitting/defaultPic.jpg'" alt="" style="width:28px;height:28px;">
                    </div>
                    <div class="member pos-a text-center right20 bottom0 flex-container center" v-show="item.reviewerType === 4">
                        <!-- <i class="icon-pd_crown text-white text-white" style="font-size: 9px;"></i> -->
                    </div>
                </div>
                <div class="flex1" style="word-wrap: break-word;width: calc(100% - 38px);">
                    <p class="fs-13 text-darker float-left" v-text="item.nickName"></p>
                    <span class="fs-11 paddingl10 text-red" v-show="item.reviewerType === 4">
                        <i class="icon-discover_daren fs-11"></i><span>官方</span>
                    </span>
                </div>
            </div>
            <!-- 评论回复 -->
            <div style="margin-left:38px">
                <div class="fs13 text-darker fs-13" v-html="item.content | htmlFilter" @click="chooseOne(item.nickName, item)" style="word-wrap: break-word;"></div>
                <div class="paddingv20 fs-11 text-light" v-text="item.timeStr"></div>
                <div class="fs-11 comment paddingh20 paddingt20 paddingb10" v-if="item.items && item.items.length">
                    <p class="paddingb10 pos-r" v-for="sub in item.items" @click.stop="chooseOne(sub.nickName, item, sub)">
                        <span class="text-red" v-text="sub.nickName"></span>
                        <span class="fs-11 paddingl10 text-white bg-red border-radius" v-show="sub.reviewerType === 4">
                            <i class="icon-discover_daren"></i><span>官方</span>
                        </span>
                        <span class="text-dark" v-html="sub.content | htmlFilter" style="word-wrap: break-word;"></span>
                        <span class="pos-a" style="top: -50px;" :id="'reply-'+sub.id"></span>
                    </p>
                    <div class="flex-container paddingb20 paddingt10 right" v-if="item.findMore">
                        <div class="badge small reverse pill" @click="moreSubReply(item)" >查看更多</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- 底部输入框 -->

<div class="flex-container vfull form paddingh30 border fixed-bottom comment bg-white" id="bottomInput" style="bottom: 0;padding-top:8px;padding-bottom:8px;z-index: 9;">
    <!--<input type="text" class="border border-radius flex1 bg-white" id="makeComment" v-model="replyContent">-->
<!--     <div class="flex1">
        <form action="" onsubmit="return false;">

            <div class="border border-red border-radius flex1 bg-white flex-container" style="padding-left: 12px;border-color: #ff4c48;flex-direction: row-reverse; overflow: hidden;">
                <textarea rows="1" style="border: 0; display: block;" id="makeComment" name="makeComment" class="textarea_placeholder"
                          :placeholder="placeholder"
                          @keydown="resetHeight($event)"
                          @focus="focusReply($event)"
                          @blur="blurReply($event)"
                          v-model="replyContent"></textarea>
                <label for="makeComment" class="icon icon-index_pen text-red"></label>
            </div>
        </form>
    </div>

    <p class="fs10 paddingl30 paddingr20 text-red" @click="reply">发送</p> -->
    <div class="flex1 fs-12 text-light paddingh20 flex-container center left" @click="popupComment = true" style="background: #FFFFFF;border: 1px solid #FF4C48;border-radius: 2px;min-height: 33px;">
        {{replyContent == '' ? placeholder : replyContent}}
    </div>
    <div class="pos-r marginl30" v-if="products && products.items && products.items.length">
        <a href="#productGL">
            <img src="//image1.51tiangou.com/tgou2/img2/discover/icon-shopping_bag.png" width="34" alt="">
            <div class="pos-a left0 right0 bottom0 text-white text-center fs-12" style="line-height:22px;" v-text="products.items.length"></div>
        </a>
    </div>

</div>
<!-- <div class="padding10 border fixed-bottom" style="background-color: transparent;right:55px;border-color:transparent;" @click="gotoInput()" v-show="showIOSInputMask">
    <div style="height:38px;"></div>
</div> -->
<!-- 遮罩层 -->
<div class="mask bottom" v-if="isChoose" style="z-index: 2147483647;">
    <div class="mask_content flex1 text-dark" style="padding-bottom:30px;">
        <a href="javascript:void(0)" class="btn big white btn-radius block margin30" @click="replyToOne(currentSubReply?currentSubReply.nickName:currentReply?currentReply.nickName:'')">
            <span class="text-dark fs18">回复</span>
        </a>
        <div></div>
        <a href="javascript:void(0)" class="btn big white btn-radius block margin30" v-if="isSA&&memberId!=currentReply.memberId" @click="reportReply">
            <span class="text-dark fs18">举报</span>
        </a>
        <div></div>
        <a href="javascript:void(0)" class="btn big white btn-radius block margin30" v-if="memberId==currentReply.memberId||memberId==currentSubReply.memberId" @click="delReply">
            <span class="text-dark fs18">删除</span>
        </a>
        <div></div>
        <a href="javascript:void(0)" class="btn big white btn-radius block marginh30 margint40" @click="hideMask">
            <span class="text-dark fs18">取消</span>
        </a>
    </div>
</div>


<cmui-popup :visible.sync="popupComment" position="top" :stop-page-scroll="true" :mask-event="false">
    <div class="bg-white paddingh20 paddingv30" style="width:100%;">
        <textarea rows="4" style="border: 0; display: block;width:100%" id="makeComment" name="makeComment" class="textarea_placeholder fs-15" 
                          :placeholder="placeholder"
                          @keydown="resetHeight($event)"
                          @focus="focusReply($event)"
                          @blur="blurReply($event)"
                          v-model="replyContent"></textarea>

    </div>
    <div slot='bottom'>
        <div class="flex-container right paddingv40 paddingh30">
            <div class="btn red reverse radius small marginl20" style="border-radius:500px;border-color: #e0e0e0;padding: 1px 10px;font-size:12px;line-height: 22px;border:1px solid #ff4c48;min-width:70px;" @click="popupComment = false">取消</div>
            <div class="btn red radius small marginl20" style="border-radius:500px;border-color: #e0e0e0;padding: 1px 10px;font-size:12px;line-height: 22px;border:0;min-width:70px;">
                <div class="flex-container center">
                    <img src="//image1.51tiangou.com/tgou2/img2/discover/icon-publish.png" width="12" alt="">
                    <span class="marginl10" @click="popupComment = false , reply()">发布</span>
                </div>
            </div>
        </div>
    </div>
</cmui-popup>
</template>

<script>
import _ from '_';
import maple from 'maple';
import $ from 'jquery';

let $body = $(document.body)
    , touchMoveEvent = function(e){
        e.preventDefault();
        return false;
    }
    , isHybrid = maple.cookie('hybrid') === 'true'
    ;

export default {
    props:{
        data: {
        	type: Array
            , default: []
        },
        memberId: {
        	type: String
            , default: ''
        }
        , isSA: {   // 是否为超级管理员
        	type: Boolean
            , default: false
        }
        , products: {
            type: Object
            , default : {}
        }
    },
    data(){
    	return {
		    isChoose: false
            , replyName: ''
            , replyContent: ''
            , replyNickName: ''
            , scrollTimeout: null
            , showIOSInputMask:maple.device('ios')//在IOS下设置input遮罩
            ,placeholder:''
            ,popupComment:false
        }
    }
    ,ready:function(){
        let textArr = [
                "点赞的都是套路，评论的才叫真爱！",
                "走心也分好几种，敢评论的最有种！",
                "勾搭评论别害羞，聊骚要做第一人！",
                "天苍苍，野茫茫，点赞留言要不要！",
                "这儿有块处女地，赶紧先下手评论！",
                "有想法就说，憋在心里多难受！",
                "矜持点赞也可以，知音难觅聊一句！"
            ];
        var index = Math.floor((Math.random()*textArr.length)); 
        this.placeholder = textArr[index];
    }
    , watch: {
		replyName(newVal){
			if( newVal ){
				this.replyContent = '回复'+ newVal +'：';
				this.replyNickName = '回复'+ newVal +'：';
			}
		}
	}
	, methods:{
	    moreSubReply: function(reply){  // 点击查看更多
	    	this.$dispatch('moreSubReply', reply);
        }
        ,gotoInput(){
            //滚动到页面最底部并且获取焦点，仅在IOS下执行，解决input位置问题
            document.body.scrollTop = document.body.scrollHeight;
            $('#makeComment').focus();
        }
        , focusReply(e){
			if( !this.inputDOM ){
                this.$set('inputDOM', e.target);
			}
            maple.device('ios')&&this.inputDOM.setAttribute('rows',4)
			this.$dispatch('focusReply');
			document.addEventListener('touchmove', touchMoveEvent, true);
		}
        , blurReply(e){
        	this.$dispatch('blurReply');
            maple.device('ios')&&this.inputDOM.setAttribute('rows',4)
			document.removeEventListener('touchmove', touchMoveEvent, true);
        	$(document).off('scroll.input');
        }
        , resetHeight(e){
	    	let $target = $(e.target)
                ;

            $target.css('height', 'auto');
            $target.css('height', ($target[0].scrollHeight) +'px');
        }

        , chooseOne(replyName, reply, subReply=null){  // 点击选择一个人

            this.$set('currentReply', reply);
            this.$set('currentSubReply', subReply);

		    if( subReply && this.memberId !== subReply.memberId ){ // 点击其它人的子评论
			    if( this.isSA ){ // 是超级管理员，可以回复、举报
                    this.showMask();
			    }
			    else{   // 普通用户，可以回复
				    this.replyToOne( replyName );
			    }
            }
            else if( subReply && this.memberId === subReply.memberId ){ // 点击子评论，是自己的可以删除
			    this.showMask();
            }
	    	else if( this.memberId === reply.memberId ){   // 点中自己的评论，可以删除
			    this.showMask();
            }
            else if( this.memberId === '' || this.memberId !== reply.memberId ){    // 点中其他人的评论
	    		if( this.isSA ){ // 是超级管理员，可以回复、举报
				    this.showMask();
                }
                else{   // 普通用户，可以回复
                    this.replyToOne( replyName );
                }
            }
        }
        , showMask(){
			this.isChoose = !this.isChoose;
        }
        , hideMask(){
        	this.isChoose = false;

			this.$delete('currentReply');
			this.$delete('currentSubReply');
        }

		, replyToOne(replyName){  // 点击评论用户昵称
            //在IOS下先滚动到最底部
            maple.device('ios')&&(document.body.scrollTop = document.body.scrollHeight);
			this.replyName = replyName;

			this.isChoose = false;

			if( !this.inputDOM ){
				// todo 其它解决方案 
				let $input = $(this.$root.$el).find('#makeComment');

				if( $input.length ){
					this.$set('inputDOM', $input[0]);
                }
			}

			// 获得焦点
			if( this.inputDOM ){
				this.inputDOM.focus();
			}
		}

		, delReply(){
            this.$dispatch('delReply', this.currentReply, this.currentSubReply || null);
		    this.isChoose = false;

		    this.$delete('currentReply');
		    this.$delete('currentSubReply');
        }
        , reportReply(){    // 举报评论

		    this.$dispatch('report', this.currentSubReply || this.currentReply, 1);
		    this.isChoose = false;

		    this.$delete('currentReply');
		    this.$delete('currentSubReply');
        }

        , reply(){
        	if( this.replyContent !== this.replyNickName || this.replyContent === '' ){

        		// 长度验证
        		if( this.replyContent.length > 200 ){
        			maple.notice('请输入少于200字');

        			return;
                }
                if( this.replyContent.length === 0 ){
        			maple.notice('评论内容不能为空!');

        			return;
                }
                maple.device('ios')&&this.inputDOM.setAttribute('rows',4)
        		this.$dispatch('reply', this.replyContent, this.currentReply ? this.currentReply : '', this.currentSubReply ? this.currentSubReply : '');
                this.replyName = '';
                this.replyNickName = '';
                this.replyContent = '';

                this.$delete('currentReply');
                this.$delete('currentSubReply');

                if( !this.inputDOM ){
                    // todo 其它解决方案
                    let $input = $(this.$root.$el).find('#makeComment');

                    if( $input.length ){
                        this.$set('inputDOM', $input[0]);
                    }
                }

                this.inputDOM && $(this.inputDOM).css('height', 'auto');
            }
            else{
        		maple.notice('评论不能为空');
            }
        }
    }
}
</script>

<style lang="scss">
    .comment{
        background-color: #f8f8f8;
    }
    #makeComment{
        height: auto;
    }
    #makeComment:focus{
        padding-left: 0;
    }
    #makeComment:focus + label{
        display: none;
    }
    .textarea_placeholder::-webkit-input-placeholder{
        color:#c1c1c1;
    }
    .textarea_placeholder::-moz-placeholder{   /* Mozilla Firefox 19+ */
        color:#c1c1c1;
    }
    .textarea_placeholder:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
        color:#c1c1c1;
    }
    .textarea_placeholder:-ms-input-placeholder{  /* Internet Explorer 10-11 */
        color:#c1c1c1;
    }
/*    .cmui-popup.fixed-full{
        top: 44px;
    }*/
</style>